"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ToolsAndTemplatesLogo___StyledSvg",
  componentId: "bxa87a-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function ToolsAndTemplatesLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M392.727 145.413h-57.272v-38.191c0-21.043-17.125-38.191-38.182-38.191H182.727c-21.057 0-38.182 17.148-38.182 38.19v38.192H87.273C55.696 145.413 30 171.115 30 202.699v76.382h19.09v95.477c0 31.584 25.697 57.287 57.274 57.287h267.272c31.577 0 57.273-25.703 57.273-57.287v-95.477H450V202.7c0-31.584-25.696-57.286-57.273-57.286zm-210-38.191h114.546v38.19H182.727v-38.19zm210 267.336c0 10.56-8.572 19.096-19.09 19.096H106.363c-10.52 0-19.091-8.536-19.091-19.096v-95.477h76.363c0 21.062 17.125 38.191 38.182 38.191h76.364c21.057 0 38.182-17.129 38.182-38.19h76.363v95.476zm-190.909-95.477v-38.19h76.364l-.057 38.19h-76.307zm210-38.19h-95.454c0-21.044-17.125-38.192-38.182-38.192h-76.364c-21.057 0-38.182 17.148-38.182 38.191H68.182V202.7c0-10.522 8.572-19.096 19.09-19.096h305.455c10.52 0 19.091 8.574 19.091 19.095v38.191z"
  }));
}

var _default = ToolsAndTemplatesLogo;
exports["default"] = _default;